(function() {
	'use strict';

	angular
		.module('sodCommon')
		.controller('DateRangePickerCtrl', DateRangePickerCtrl);

	function DateRangePickerCtrl(close, $timeout, options, $element, lodash, model) {
		var drpVm = this;
		var date_picker_dom = $element.find('.date');

		var formatDisplay = lodash.get(options, 'datepicker.format_display', 'D MMM YYYY');
		var formatValue = lodash.get(options, 'datepicker.format_value', 'YYYY-M-D');

		$timeout( function () {
			drpVm.show = true;
		} );

		drpVm.model = model || {};

		drpVm.dismiss = dismiss;
		drpVm.confirm = confirm;

		init();

		function dismiss() {
			close(false, 250);
		}

		function confirm() {
			close(drpVm.model, 250);
		}

		function init() {
			date_picker_dom.datepicker(angular.merge(
				{
					// 'autoclose': true,
					'orientation': 'auto bottom',
					// 'toggle'
				},
				lodash.get(options, 'datepicker', {}),
				{
					'format': {
						toDisplay: function(date, format, language) {
							return moment(date, formatValue).format(formatDisplay);
						},
						toValue: function(date, format, language) {
							return moment(date, formatValue).format(formatDisplay);
						}
					},
					changeDate: function() {
						var currentDateObj = this;
						console.log('changeDate', currentDateObj);
					}
				}
			));
		}
	}
})();